import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  USER_PROFILES_CREATE_PROFILE,
  USER_PROFILES_DELETE_PROFILE,
  USER_PROFILES_EDIT_PROFILE,
  USER_PROFILES_MANAGE_ATTRIBUTIONS,
} from '@app/@core/constants/routes.constants';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { UsersProfileGuard } from './user-profiles.guard';

const routes: Routes = [
  {
    path: USER_PROFILES_CREATE_PROFILE,
    loadChildren: () => import('./create-profile/create-profile.module').then((m) => m.CreateProfileModule),
    data: { title: marker('sidenav.menu.create.profile') },
    canActivate: [UsersProfileGuard],
  },
  {
    path: USER_PROFILES_MANAGE_ATTRIBUTIONS,
    loadChildren: () => import('./manage-attribution/manage-attribution.module').then((m) => m.ManageAttributionModule),
    data: { title: marker('sidenav.menu.manage.attributions') },
    canActivate: [UsersProfileGuard],
  },
  {
    path: USER_PROFILES_DELETE_PROFILE,
    loadChildren: () => import('./delete-profile/delete-profile.module').then((m) => m.DeleteProfileModule),
    data: { title: marker('sidenav.menu.delete.profile') },
    canActivate: [UsersProfileGuard],
  },
  {
    path: USER_PROFILES_EDIT_PROFILE,
    loadChildren: () => import('./edit-profile/edit-profile.module').then((m) => m.EditProfileModule),
    data: { title: marker('sidenav.menu.edit.profile') },
    canActivate: [UsersProfileGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserProfilesRoutingModule {}
